<template>
  <header class="header">
    <nav class="nav">
      <h1 class="logo">Passguard<span class="text-highlight">9000</span></h1>
      <div class="nav-content">
        <ul class="nav-links" v-if="!isSmallScreen">
          <li>
            <a href="#current-features">About</a>
          </li>
          <li>
            <a href="#gallery">Gallery</a>
          </li>
          <li>
            <a href="#future-features">Feature Roadmap</a>
          </li>
          <li>
            <a href="#contact">Contact</a>
          </li>
        </ul>
        <BurgerMenu
          v-if="isSmallScreen"
          :isOpen="isMenuOpen"
          :closeOnNavigation="true"
          @closeMenu="closeMenu"
        >
          <div class="burger-links">
            <a href="#current-features" @click="closeMenu">About</a>
            <a href="#future-features" @click="closeMenu">Feature Roadmap</a>
            <a href="#gallery" @click="closeMenu">Gallery</a>
            <a href="#contact" @click="closeMenu">Contact</a>
            <router-link to="/download" class="burger-btn" @click="closeMenu">
              Download Now
            </router-link>
          </div>
        </BurgerMenu>
      </div>
    </nav>

    <div class="hero">
      <h2>Effortless Password Management</h2>
      <p>
        Own your data, secure your credentials, and never worry about
        subscriptions or data leaks.
      </p>
      <router-link to="/download" class="hero-btn">Download Now</router-link>
    </div>
  </header>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import { Slide as BurgerMenu } from "vue3-burger-menu";

export default {
  name: "AppHeader",
  components: {
    BurgerMenu,
  },
  setup() {
    const isMenuOpen = ref(false);
    const isSmallScreen = ref(window.innerWidth <= 768);

    const toggleMenu = () => {
      isMenuOpen.value = !isMenuOpen.value;
    };

    const closeMenu = () => {
      isMenuOpen.value = false;
    };

    const handleResize = () => {
      isSmallScreen.value = window.innerWidth <= 768;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    return {
      isMenuOpen,
      toggleMenu,
      closeMenu,
      isSmallScreen,
    };
  },
};
</script>

<style scoped>
@import "@/styles/components/Header.scss";
</style>

<!-- 
<template>
  <header class="header">
    <div class="container">
      <nav class="nav">
        <h1 class="logo">Passguard<span class="text-highlight">9000</span></h1>
        <ul :class="['nav-links', { active: isMenuOpen }]">
          <li>
            <a href="#current-features" @click="closeMenu">About</a>
          </li>
          <li>
            <a href="#future-features" @click="closeMenu">Feature Roadmap</a>
          </li>
          <li><a href="#gallery" @click="closeMenu">Gallery</a></li>
          <li><a href="#contact" @click="closeMenu">Contact</a></li>
        </ul>
        <div class="hamburger" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>
    </div>
    <div class="hero">
      <h2>Effortless Password Management</h2>
      <p>
        Own your data, secure your credentials, and never worry about
        subscriptions or data leaks.
      </p>
      <router-link to="/download" class="hero-btn">Download Now</router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
  },
};
</script>

<style scoped>
@import "@/styles/components/Header.scss";
</style>
-->
